import PaymentType from '../Models/PaymentType';
import DataGridRequest from './DataGridRequest';
export class PaymentTypeRequest extends DataGridRequest<PaymentType> {
    Url = '/api/v1/settings/payment_types';
}
